export default function TentangSurvey(params) {
  return (
    <div>TentangSurvey</div>
  )
}